// NGRP Namaskar — founder's opening invitation and the Governance Reform Dialogue framing.
// Content authored by the party leadership. Rendered on /dialogue and previewed on Home.

export const NAMASKAR = {
  greeting: "Namaskar.",
  paragraphs: [
    "We have spent years asking why corruption, administrative delays, unemployment, poor public services and political interference continue despite India having enormous talent.",
    "I believe the solution cannot be only to criticise the existing system. Capable citizens must participate in changing it.",
    "That is why we are building the National Governance Reform Party \u2014 NGRP.",
  ],
  philosophy: "Transparent Governance. Merit-Based Leadership. A Stronger India.",
  invited_line:
    "We want UPSC/MPSC aspirants, engineers, doctors, teachers, farmers, entrepreneurs, professionals, women and young citizens to participate directly in building better governance.",
  invited_groups: [
    "UPSC / MPSC aspirants",
    "Engineers",
    "Doctors",
    "Teachers & professors",
    "Farmers",
    "Entrepreneurs",
    "Professionals",
    "Women leaders",
    "Young citizens",
  ],
  disclaimer: [
    "This is not an invitation to follow an individual.",
    "It is an invitation to help build a system where knowledge, integrity, public service and performance create leadership.",
  ],
  first_ask: {
    kicker: "Before asking you to join NGRP, we want to hear from you.",
    question: "What are the five biggest reforms India needs?",
    cta: "Participate in our Governance Reform Dialogue.",
  },
  sequence: "Let us first build the ideas, then the organisation, and finally the leadership India deserves.",
  signature_lines: [
    "National Governance Reform Party (NGRP)",
    "Knowledge \u2192 Public Service \u2192 Performance \u2192 Public Trust \u2192 Leadership",
  ],
};
